// extracted by mini-css-extract-plugin
export default {"wrap":"Main_wrap__rVxaO"};